<mat-toolbar color="primary" class="toolbar">
  <span>Back Office</span>
  <span class="spacer"></span>
  <span class="date-time">{{ formattedTime() }}</span>

  <button mat-icon-button (click)="darkMode.set(!darkMode())">
    @if (darkMode()) {
    <mat-icon class="material-symbols-outlined">light_mode</mat-icon>
    } @else {
    <mat-icon class="material-symbols-outlined">dark_mode</mat-icon>
    }
  </button>
  @if(isAuthenticated()) {
  <button mat-icon-button (click)="logout()">
    <mat-icon class="material-symbols-outlined">logout</mat-icon> </button
  >}
</mat-toolbar>
